<script setup lang="ts">
import BeforeAfterSlider from '@/components/Tools/BeforeAfterSlider.vue';

defineProps<{
    beforeSrc: string;
    afterSrc: string;
}>();
</script>

<template>
    <BeforeAfterSlider :before-src="beforeSrc" :after-src="afterSrc" />
</template>
